import { ScrollArea } from "@mantine/core";
import { forwardRef } from "react";
import { type ILogbook } from "src/interfaces";
import { Flex, SectionDivider } from "src/styled";

import LogbookItem from "./LogbookItem";
import { type Position } from "./LogbooksSelector";

interface Props {
  title: string;
  logbooks: ILogbook[];
  targetPosition?: Position;
}

const LogbooksDrop = forwardRef<HTMLDivElement, Props>(
  ({ title, logbooks, targetPosition }, ref) => {
    return (
      <Flex ref={ref} flex={1} direction="column" gap={30}>
        <SectionDivider>{title}</SectionDivider>
        <ScrollArea
          style={{ height: "calc(100vh - 104px - 250px)" }}
          type="auto">
          <Flex direction="column" gap={20} p={12} pl="10%">
            {logbooks.map((log, index) => (
              <LogbookItem
                key={log?.lbid ?? index}
                logbook={log}
                targetPosition={targetPosition}
              />
            ))}
          </Flex>
        </ScrollArea>
      </Flex>
    );
  },
);

export default LogbooksDrop;
